export const ALLOWED_CHARS = /^[a-zA-Z\sæÆøØåÅüÁáČčĐđŊŋŠšŦŧŽž%0-9\-−:+,’/.()]*$/
export const ALLOWED_LETTERS = /^[a-zA-Z\sæÆøØåÅÁáČčĐđŊŋŠšŦŧŽž-]*$/
